(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["image-protection"] && !Shopify.designMode) return;
  try {
    (() => {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;

    const isProtectedImage = (target) =>
      target instanceof Element &&
      Boolean(target.closest('img:not([data-allow-image-save])'));

    document.addEventListener(
      'contextmenu',
      (event) => {
        if (isProtectedImage(event.target)) event.preventDefault();
      },
      { capture: true }
    );

    document.addEventListener(
      'dragstart',
      (event) => {
        if (isProtectedImage(event.target)) event.preventDefault();
      },
      { capture: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
